<div class="week-pagination-wrapper" *ngIf="startDate && endDate">
    <mat-icon matTooltip="Vorherige Woche" (click)="previousWeek()">chevron_left</mat-icon>
    <span>{{startDate|date:'dd. MM. yyyy'}} – {{endDate|date:'dd. MM. yyyy'}}</span>
    <mat-icon matTooltip="Nächste Woche" (click)="nextWeek()">chevron_right</mat-icon>
</div>